import { useCanvasLabelStyle } from "../hooks/useCanvasLabelStyle";
import type { TextPlacementGhost } from "../hooks/useTextLabelPlacement";
import {
  TEXT_LABEL_PLACEHOLDER,
  TEXT_LABEL_PLACEHOLDER_COLOR,
  TEXT_LABEL_TEXT_PADDING,
} from "../types/canvasNodeData";

/**
 * The label about to be placed: same box, inset, font and prompt as the node
 * that replaces it, at the position it will be dropped on. A leaf so the
 * sticky-style subscription re-renders nothing else.
 */
export function TextLabelPlacementGhost({
  ghost,
}: {
  ghost: TextPlacementGhost;
}) {
  const labelStyle = useCanvasLabelStyle();

  if (ghost.dragWidth) {
    return (
      <div
        className="absolute pointer-events-none"
        style={{
          left: ghost.position.x,
          top: ghost.position.y,
          width: ghost.dragWidth,
          minHeight: 32,
          border: "2px dashed hsl(var(--primary) / 0.6)",
          borderRadius: "4px",
          backgroundColor: "hsl(var(--primary) / 0.05)",
        }}
      />
    );
  }

  return (
    <div
      className="canvas-label-ghost-preview absolute pointer-events-none select-none"
      style={{ left: ghost.position.x, top: ghost.position.y }}
    >
      <div className="absolute -inset-px rounded-[3px] border-2 border-canvas-selection/60" />
      <div
        style={{
          fontFamily: labelStyle.font_family,
          fontSize: labelStyle.font_size,
          fontWeight: labelStyle.is_bold ? "bold" : 400,
          fontStyle: labelStyle.is_italic ? "italic" : "normal",
          textDecoration: labelStyle.is_underline ? "underline" : "none",
          color: TEXT_LABEL_PLACEHOLDER_COLOR,
          padding: TEXT_LABEL_TEXT_PADDING,
          whiteSpace: "pre",
        }}
      >
        {TEXT_LABEL_PLACEHOLDER}
      </div>
    </div>
  );
}
